import React, { useState, useRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import { Typeahead } from 'react-bootstrap-typeahead'
import { InputGroup } from 'react-bootstrap'

const MySearch = (props) => {
  const data = props.dataSeacrh
  const [disabled] = useState({})
  const [isCheckedAsegurado, setIsCheckedAsegurado] = useState(false)
  const [isCheckedImplicado, setIsCheckedImplicado] = useState(false)
  const typeaheadRef = useRef(null)

  const onSubmit = (value) => {
    props.setDataTable(
      props.baseProps.data.filter((item) => item.IdImplicado === 0)
    )
  }

  const handleClear = () => {
    typeaheadRef.current.clear()
    props.setDataTable(props.dataOriginal)
  }

  const handleOnChange = () => {
    setIsCheckedAsegurado(!isCheckedAsegurado)
    !isCheckedAsegurado
      ? props.setDataTable(
          props.baseProps.data.filter((item) => item.IdImplicado === 0)
        )
      : props.setDataTable(props.dataOriginal)
  }

  const handleOnChangeImplicado = () => {
    setIsCheckedImplicado(!isCheckedImplicado)
    !isCheckedImplicado
      ? props.setDataTable(
          props.baseProps.data.filter((item) => item.IdImplicado >= 1)
        )
      : props.setDataTable(props.dataOriginal)
  }

  return (
    <Row className='m-4'>
      <Col md='2' className='mt-1'>
        <input
          className='form-check-input m-1'
          type='checkbox'
          id='Asegurado'
          checked={isCheckedAsegurado}
          onChange={handleOnChange}
        />
        Asegurado
      </Col>
      <Col md='2' className='mt-1'>
        <input
          className='form-check-input m-1'
          type='checkbox'
          checked={isCheckedImplicado}
          onChange={handleOnChangeImplicado}
        />
        Implicado
      </Col>

      <Col md='4'>
        <InputGroup>
          <Typeahead
            ref={typeaheadRef}
            id='NombreImplicado'
            onChange={(e) => {
              onSubmit()
            }}
            labelKey='NombreImplicado'
            options={data ? data : []}
            disabled={disabled[data]}
          />
          <InputGroup.Text onClick={handleClear}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-x'
              viewBox='0 0 16 16'
            >
              <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
            </svg>
          </InputGroup.Text>
        </InputGroup>
      </Col>
    </Row>
  )
}
export default MySearch
